import DataTable from 'components/ui/DataTable/data-table';
import { FC, useState } from 'react';
import { BiLastPage } from 'react-icons/bi';
import { useListServiceQuery } from 'redux/reducers/master';
import EditIcon from '../../../../assets/images/icons/edit.png';
import DeleteIcon from '../../../../assets/images/icons/delete.png';
import { useParams } from 'react-router-dom';
import ServiceGroupBadge from 'components/ui/ServiceGroupBadge';

interface ITMasterDataTable {
  tableHeaders: () => React.ReactNode;
  onDeleteClicked: (data: any) => void;
  onEditClicked: (data: any) => void;
}

const MasterDataTable: FC<ITMasterDataTable> = ({
  tableHeaders,
  onDeleteClicked,
  onEditClicked
}) => {
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;

  const { data: response, isLoading } = useListServiceQuery();

  const masterData = response?.data || [];

  const totalItems = masterData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const paginatedData = masterData.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const canPrevious = page > 1;
  const canNext = page < totalPages;

  const columns = [
    {
      Header: 'Name',
      accessor: 'name'
    },
    {
      Header: 'Status',
      accessor: (data: any) => {
        return <ServiceGroupBadge status={data?.status} />;
      }
    },
    {
      Header: 'Action',
      accessor: (data: any) => {
        return (
          <>
            <img src={EditIcon} className="icons" onClick={() => onEditClicked(data?.id)} />
            <img src={DeleteIcon} className="m-2 icons" onClick={() => onDeleteClicked(data)} />
          </>
        );
      }
    }
  ];
  return (
    <div className="list form-check-all">
      <DataTable
        columns={columns}
        data={paginatedData || []}
        tableHeaders={tableHeaders}
        isLoading={isLoading}
        pagination={{
          canNext,
          canPrevious,
          prevPage: () => {
            if (totalItems) {
              page > 1 && setPage(page - 1);
            }
          },
          nextPage: () => {
            if (totalItems) {
              totalItems?.length >= masterData && setPage(page + 1);
            }
          }
        }}
      />
    </div>
  );
};
export default MasterDataTable;
